import { defineSchema } from '../../schema-meta.ts';
import { registerCategorySchema } from '../../registry.ts';
import { QUEST_TYPE } from '../../enum-registry.ts';

export const QuestSchema = defineSchema({
  name: 'serverQuests',
  fields: [
    ['id', 'number'],
    ['questType', { kind: 'enum', name: 'QuestType', members: QUEST_TYPE }],
    ['clearCondition', { kind: 'dict', dict: 'clear-condition' }],
    ['rewards', { kind: 'dict', dict: 'delivery' }],
    ['isActive', 'boolean'],
  ],
  lookupKeys: ['id'],
});

export interface RawQuestRow {
  id: number;
  quest_type: string;
  clear_condition: Record<string, unknown>;
  rewards: Record<string, number>;
  is_active: boolean;
}

export function questFromRaw(row: RawQuestRow) {
  return {
    id: row.id,
    questType: row.quest_type,
    clearCondition: row.clear_condition,
    rewards: row.rewards,
    isActive: row.is_active,
  };
}

registerCategorySchema('serverQuests', QuestSchema);
